export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9667.282bd014.jpg";